document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.product-addtocart_button');
  if (!btn) return;

  e.preventDefault();

  // Find variant dropdown near this button (same card/section)
  const wrap = btn.closest('.product-card, .grid__item, .card, .product, .section') || btn.parentElement;
  const select = wrap ? wrap.querySelector('.variant-dropdown[data-variant-select]') : null;

  const variantId = select?.value || btn.getAttribute('data-default-variant-id');
  if (!variantId) {
    console.warn('No variantId found for add to cart.');
    return;
  }

  btn.disabled = true;
  btn.classList.add('is-loading');

  try {
    const body = new URLSearchParams();
    body.set('id', String(variantId));
    body.set('quantity', '1');

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body
    });

    const json = await res.json();
    if (!res.ok) throw new Error(json?.description || json?.message || 'Add to cart failed');

    // Open your drawer (from my previous code)
    if (window.CustomCartDrawer && typeof window.CustomCartDrawer.open === 'function') {
      window.CustomCartDrawer.open();
    } else {
      // fallback if drawer not loaded
      window.location.href = '/cart';
    }
  } catch (err) {
    console.error(err);
    alert(err.message || 'Failed to add to cart');
  } finally {
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }
});
